import React from 'react'

export default function Hero() {
  return (
    <div className='flex flex-col relative z-10 items-center justify-center h-screen py-[5%] px-[3%]' id='home'>
      <p className='md:text-5xl text-3xl text-white font-bold uppercase mb-3 font-capital'>Ulfatun Amanah</p>
      <p className='md:text-2xl text-xl text-white font-medium text-center w-[55%]'>A Front End Developer with highly skilled in HTML, CSS, JavaScript, React JS, and Next Js</p>
      <a href='#about' className='bg-[#8cb7be] text-white font-medium md:text-base text-sm rounded-full my-4 px-4 py-3'>Get Started</a>
    </div>
  )
}
